import restRequest from '@/services/restRequest'
import { signHeaderField } from '@/services/sign/getSign-obfuscated'
import { mixApi, AgResponse } from '../config';

export interface PersonalAccount {
  name?: string; // 用户名称
  real_name?: string; // 实名制用户名称
  account_phone?: string; // 用户中心-手机号
  phone?: string; // 农服的手机号
  avatar?: string; // 头像
  uid?: string; // 用户唯一id
}

export interface PersonalProfile extends PersonalAccount {
  account?: string; // 用户中心-邮箱
  flyer?: PersonalProfile;
  work_area?: number;
  work_times?: number;
  work_time?: number;
}

export interface PersonalPwd {
  old_password: string;
  new_password: string;
  confirm_password: string;
}


// 初始化时，initState未写入服务端host
export const fetchPersonalProfileInit = async (server) => {
  const url = server + '/api/orders/v2/profile'
  const signHeader = await signHeaderField(url) || {}
  return await restRequest.get<AgResponse<PersonalProfile>>(url, {
    headers: {
      'Accept': 'application/json',
      ...signHeader
    }
  })
}

export const fetchPersonalProfile = async () => {
  return await restRequest.get<AgResponse<PersonalProfile>>(mixApi('/api/orders/v2/profile'))
}

export const fetchUpdatePwd = async (query: PersonalPwd) => {
  return await restRequest.post<AgResponse<any>>(mixApi('/api/orders/v1/new_password'), query)
}
